/**
 * Fade in chat bubbles on scroll when they are visible
 *
 * @param {NodeList} chatBubbles - The chat bubbles to fade in
 *
 * @return {void}
 */
const chatBubbleFadeIn = (chatBubbles) => {
  if (!chatBubbles) return;

  const observerOptions = {
    root: null, // Use the viewport as the root
    rootMargin: '0px',
    threshold: 0.1, // Trigger when at least 10% of the element is visible
  };

  /**
   * Callback for the IntersectionObserver
   *
   * @param {IntersectionObserverEntry[]} entries - The entries to observe
   *
   * @return {void}
   */
  const observerCallback = (entries) => {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        entry.target.classList.add('plarium-play__chat-conversation__message__bubble--visible');
      } else {
        entry.target.classList.remove('plarium-play__chat-conversation__message__bubble--visible');
      }
    });
  };

  const observer = new IntersectionObserver(observerCallback, observerOptions);

  chatBubbles.forEach((chatBubble) => {
    observer.observe(chatBubble);
  });
};

export default chatBubbleFadeIn;
